import cryptoJs from 'crypto-js';

import { GiftCode } from '@/models/GiftCode';

const keySize = 256 / 32;

// eslint-disable-next-line import/prefer-default-export
export class GiftCodeCrypto {
  private key: cryptoJs.WordArray;

  constructor(password: string) {
    this.key = cryptoJs.PBKDF2(password, 'salt', {
      keySize,
    });
  }

  public encryptString(str: string) {
    const iv = cryptoJs.lib.WordArray.random(16);
    const options = { iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
    const encrypted = cryptoJs.AES.encrypt(cryptoJs.enc.Utf8.parse(str), this.key, options);

    return {
      encrypted: cryptoJs.enc.Hex.stringify(encrypted.ciphertext),
      iv: cryptoJs.enc.Hex.stringify(iv),
    };
  }

  public decryptString(encrypted: string, encryptIv: string) {
    const hexParsedEncryptedGiftCode = cryptoJs.enc.Hex.parse(encrypted);
    const iv = cryptoJs.enc.Hex.parse(encryptIv);
    const options = { iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
    const decrypted = cryptoJs.AES.decrypt(
      { ciphertext: hexParsedEncryptedGiftCode, salt: '', iv: '' },
      this.key,
      options
    ).toString(cryptoJs.enc.Utf8);

    return decrypted;
  }

  public encryptGiftCode(giftCode: GiftCode): GiftCode {
    const iv = cryptoJs.lib.WordArray.random(16);
    const options = { iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
    const encrypted = cryptoJs.AES.encrypt(cryptoJs.enc.Utf8.parse(giftCode.code), this.key, options);

    return { ...giftCode, code: cryptoJs.enc.Hex.stringify(encrypted.ciphertext), iv: cryptoJs.enc.Hex.stringify(iv) };
  }

  public decryptGiftCode(encryptedGiftCode: GiftCode): GiftCode {
    const hexParsedEncryptedGiftCode = cryptoJs.enc.Hex.parse(encryptedGiftCode.code);
    const iv = cryptoJs.enc.Hex.parse(encryptedGiftCode.iv);
    const options = { iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
    const decrypted = cryptoJs.AES.decrypt(
      { ciphertext: hexParsedEncryptedGiftCode, salt: '', iv: '' },
      this.key,
      options
    ).toString(cryptoJs.enc.Utf8);

    return { ...encryptedGiftCode, code: decrypted || 'ギフトコードの復号に失敗しています' };
  }
}
